interface Props {
  value: number;
}

export function Counter({ value }: Props) {
  return (
    <div className="flex items-center justify-center w-6 h-6 bg-[#F0F1F4] dark:bg-gray-600 text-gray-700 dark:text-invertedPrimary80 text-[14px] font-[500] leading-none non-selectable rounded">
      {value}
    </div>
  );
}
